import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import ButtonCustom from "src/shared/components/buttons/ButtonCustom";
import {
  CalendarToday,
  Check,
  LocationOn,
  Timelapse,
} from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import TabsReservation from "./TabsReservationImagenologia";
import { userState } from "src/store/user/userState";
import { grey } from "@mui/material/colors";
import { useTheme } from "@emotion/react";
import {
  capitalizeWord,
  serializeDateFormatLong,
  nameSede,
} from "src/shared/global/helpers";
import {
  errorsFormRegisterState,
  errorsReservationGuestState,
  errorsReservationUserState,
  valuesFormRegisterState,
  valuesFormReservationGuestState,
  valuesFormReservationUserState,
} from "src/Patient/state/atoms";
import { useSaveReservationImagenologia } from "./hooks/useSaveReservationImagenologia";
import ProfessionalName from "src/Professional/ProfessionalName";
import ProfessionalSpecialities from "src/Professional/ProfessionalSpecialities";
import ProfessionalImagenologia from "src/Professional/ProfessionalImagenologia";
import { useEffect } from "react";
import ModalTitleCustom from "src/shared/components/modals/ModalTitle";
import ReactGA from "react-ga4";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";

import {
  existPatientState,
  filterSearchSelectedState,
} from "../SearchHours/state/atoms";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  ".contFechaLogeado": {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },

  ".contFechaNoLogeado": {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },

  ".prestador": {
    marginTop: "1rem",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
  },

  ".formularioAcceso": {
    margin: 0,
    height: "100%",
    width: "100%",
    alignItems: "center",
  },

  [theme.breakpoints.up("xs")]: {
    ".contFechaNoLogeado": {
      padding: "1rem 0",
    },
  },

  [theme.breakpoints.up("md")]: {
    ".contFechaNoLogeado": {
      paddingRight: "1rem",
    },

    ".usuarioLogeado": {
      padding: "1rem",
    },

    ".usuarioSinLogear": {
      padding: "1rem",
    },
  },
}));

export default function ModalReservationImagenologia() {
  const resetErrorsFormGuest = useResetRecoilState(errorsReservationGuestState);
  const setValuesFormReservationGuest = useSetRecoilState(
    valuesFormReservationGuestState
  );
  const resetValuesFormGuest = () => {
    setValuesFormReservationGuest((prev) => {
      return {
        ...prev,
        usuApePat: null,
        usuApeMat: null,
        usuNombres: null,
        usuFono: null,
        usuCelular: null,
        ageEmail: null,
        ageEmailConfirm: null,
        fechaNac: null,
        isaCodigo: null,
      };
    });
  };
  const resetErrorsFormUser = useResetRecoilState(errorsReservationUserState);
  const resetValuesFormUser = useResetRecoilState(
    valuesFormReservationUserState
  );
  const resetValuesFormUserRegister = useResetRecoilState(
    valuesFormRegisterState
  );
  const resetErrorsFormRegister = useResetRecoilState(errorsFormRegisterState);
  const user = useRecoilValue(userState);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const [indicacionesTexto, setTextoIndicaciones] = useState("");

  let {
    handleClickSaveReservation,
    loadingSaved,
    hourSelected,
    setHourSelected,
    showModal,
    setShowModal,
  } = useSaveReservationImagenologia();

  const theme = useTheme();

  const handleClose = (ev, reason) => {
    if (reason && reason === "backdropClick") return;

    resetErrorsFormGuest();
    resetValuesFormGuest();
    resetErrorsFormUser();
    resetValuesFormUser();
    resetValuesFormUserRegister();
    setHourSelected(null);
    setShowModal(false);
    resetErrorsFormRegister();
  };

  useEffect(() => {
    return () => {
      resetErrorsFormGuest();
      resetValuesFormGuest();
      resetErrorsFormUser();
      resetValuesFormUser();
      resetValuesFormUserRegister();
      resetErrorsFormRegister();
      setTextoIndicaciones(hourSelected?.professional.indicacionesPaciente);
    };
  }, []);

  const confirmar = () => {
    eventGA();
    handleClickSaveReservation();
  };

  const eventGA = () => {
    let tipoExamen = filterSearchSelected.tipoExamenSelected.value;
    tipoExamen = tipoExamen != "" ? `TipoExamen: ${tipoExamen}` : "";
    let examen = filterSearchSelected.examenSelected.value;
    examen = examen != "" ? `| Examen: ${examen}` : "";
    ReactGA.event({
      category: "Buscar",
      action: `${tipoExamen} ${examen}`,
    });
  };

  const Indicaciones = (data) => {
    let texto = "";
    let myArray = [];
    let titulo = "";
    let descripcion = "";
    let myArrayDescripcion = [];

    try {
      texto = hourSelected?.professional.indicacionesPaciente;
      texto = typeof texto === "undefined" ? "" : texto;
      if (texto.length > 0) {
        myArray = texto.split(";");
        titulo = myArray[0];
        descripcion = myArray[1];
        myArrayDescripcion = descripcion.split(",");
      } else {
      }
    } catch (error) {
      return (
        <>
          <Grid item xs={12} md={12} mr={2}>
            <Typography
              style={{
                fontWeight: "600",
                fontSize: 14,
                backgroundColor: "#fff9c4",
                color: "#f57f17",
                padding: "0.25rem 0.5rem",
              }}
            >
              Indicaciones
            </Typography>
            <Typography
              style={{
                fontSize: 12,
                backgroundColor: "#F9FAFB",
                padding: "0.25rem 0.5rem",
              }}
            >
              {texto}
            </Typography>
          </Grid>
        </>
      );
    }

    if (titulo.length > 0) {
      return (
        <>
          <Grid item xs={12} md={12} mr={2}>
            <Typography
              style={{
                fontWeight: "600",
                fontSize: 14,
                backgroundColor: "#fff9c4",
                color: "#f57f17",
                padding: "0.25rem 0.5rem",
              }}
            >
              {titulo}
            </Typography>
            <Typography
              style={{
                fontSize: 12,
                backgroundColor: "#F9FAFB",
                padding: "0.25rem 0.5rem",
              }}
            >
              <List dense={true}>
                {myArrayDescripcion.map((item, i) => (
                  <ListItemText key={i} disablePadding>
                    <ListItemText primary={`・ ${item}`} />
                  </ListItemText>
                ))}
              </List>
            </Typography>
          </Grid>
        </>
      );
    } else {
      return <></>;
    }
  };

  const Indicaciones2 = (data) => {
    let texto2 = "";
    let myArray2 = [];
    let titulo2 = "";
    let descripcion2 = "";
    let myArrayDescripcion2 = [];

    try {
      texto2 = hourSelected?.professional.indicacionesEspecificas;
      texto2 = typeof texto2 === "undefined" ? "" : texto2;
      if (texto2.length > 0) {
        myArray2 = texto2.split(";");
        titulo2 = myArray2[0];
        descripcion2 = myArray2[1];
        myArrayDescripcion2 = descripcion2.split(",");
      } else {
      }
    } catch (error) {
      return (
        <>
          <Grid item xs={12} md={12} mr={2}>
            <Typography
              style={{
                fontWeight: "600",
                fontSize: 14,
                backgroundColor: "#fff9c4",
                color: "#f57f17",
                padding: "0.25rem 0.5rem",
              }}
            >
              Indicaciones
            </Typography>
            <Typography
              style={{
                fontSize: 12,
                backgroundColor: "#F9FAFB",
                padding: "0.25rem 0.5rem",
              }}
            >
              {texto2}
            </Typography>
          </Grid>
        </>
      );
    }

    if (titulo2.length > 0) {
      return (
        <>
          <Grid item xs={12} md={12} mr={2}>
            <Typography
              style={{
                fontWeight: "600",
                fontSize: 14,
                backgroundColor: "#fff9c4",
                color: "#f57f17",
                padding: "0.25rem 0.5rem",
              }}
            >
              {titulo2}
            </Typography>
            <Typography
              style={{
                fontSize: 12,
                backgroundColor: "#F9FAFB",
                padding: "0.25rem 0.5rem",
              }}
            >
              <List dense={true}>
                {myArrayDescripcion2.map((item, i) => (
                  <ListItemText key={i} disablePadding>
                    <ListItemText primary={`・ ${item}`} />
                  </ListItemText>
                ))}
              </List>
            </Typography>
          </Grid>
        </>
      );
    } else {
      return <></>;
    }
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <BootstrapDialog
        fullWidth
        maxWidth={user.isAuthenticated ? "xs" : "lg"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={showModal}
      >
        <ModalTitleCustom id="customized-dialog-title" onClose={handleClose}>
          Confirmar hora
        </ModalTitleCustom>

        <DialogContent>
          <Grid container>
            <Grid
              container
              item
              xs={12}
              md={user.isAuthenticated ? 12 : 5}
              style={{ height: "fit-content" }}
            >
              <Grid className="prestador">
                <Grid width={64}>
                  <ProfessionalImagenologia
                    width={64}
                    height={100}
                    image={hourSelected?.professional.imagen}
                    alt={hourSelected?.professional.ptdNombre}
                    rut={hourSelected?.professional.ptdRut}
                  />
                </Grid>

                <Grid ml={1}>
                  <ProfessionalName
                    fontSize={20}
                    nameProfessional={hourSelected?.professional.ptdNombre}
                  />
                  <ProfessionalSpecialities
                    specialities={hourSelected?.professional.especialidades}
                  />
                </Grid>
              </Grid>

              <Indicaciones key={1} data={indicacionesTexto} />
              <Indicaciones2 key={2} data={indicacionesTexto} />

              <Grid
                container
                className={
                  user.isAuthenticated
                    ? "contFechaLogeado"
                    : "contFechaNoLogeado"
                }
                borderBottom={`1px solid ${theme.palette.default.main}`}
              >
                <Grid item className="fechaConfirmada">
                  <Typography
                    display={"flex"}
                    alignItems={"center"}
                    fontWeight={500}
                  >
                    <CalendarToday
                      style={{ color: grey[300], marginRight: 5 }}
                    />
                    {capitalizeWord(
                      serializeDateFormatLong(
                        hourSelected?.hourSelected.ageFecha,
                        true
                      )
                    )}
                  </Typography>
                </Grid>

                <Grid item className="horaConfirmada">
                  <Typography
                    display={"flex"}
                    alignItems={"center"}
                    fontWeight={500}
                  >
                    <Timelapse style={{ color: grey[300], marginRight: 5 }} />
                    {hourSelected?.hourSelected.ageInicio}
                  </Typography>
                </Grid>

                <Grid item className="sedeConfirmada" alignContent={"center"}>
                  <Typography
                    display={"flex"}
                    alignItems={"center"}
                    fontWeight={500}
                    color={theme.palette.secondary.main}
                  >
                    <LocationOn style={{ color: grey[300], marginRight: 5 }} />
                    {nameSede(process.env.REACT_APP_SEDE)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {!user.isAuthenticated ? (
              <Grid item xs={12} md={7}>
                <Grid
                  item
                  className="formularioAcceso"
                  style={{ border: `2px solid ${theme.palette.default.main}` }}
                >
                  <TabsReservation />
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonCustom
            loading={loadingSaved}
            color="secondary"
            onClick={confirmar}
            text="CONFIRMAR RESERVA"
            icon={<Check />}
          />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
